module.exports = __webpack_public_path__ + "media/images/uppy-4270590fdab6586379d468b4ef303a1c.png";